import React, { useState, useEffect } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Sidebar from './Sidebar';
import Swal from 'sweetalert2';
import { getPortfolio, createPortfolio, updatePortfolio, deletePortfolio } from '../api/auth/portfolioService';

function Portfolioupdate() {
  const [values, setValues] = useState({
    image: null,
    name: '',
  });

  const [editingId, setEditingId] = useState(null);
  const [portfolioData, setPortfolioData] = useState([]);

  useEffect(() => {
    fetchPortfolioData();
  }, []);

  const fetchPortfolioData = async () => {
    try {
      const data = await getPortfolio();
      setPortfolioData(data);
    } catch (error) {
      console.error('Error fetching portfolio data:', error);
      Swal.fire('Error', 'Failed to fetch portfolio data.', 'error');
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'image') {
      setValues((prev) => ({
        ...prev,
        image: files[0],
      }));
    } else {
      setValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    const currentDate = new Date().toISOString().split('T')[0];

    formData.append('name', values.name);
    formData.append('date', currentDate);

    if (values.image) {
      formData.append('image', values.image);
    }

    try {
      if (editingId) {
        // UPDATE
        await updatePortfolio(editingId, formData);
        Swal.fire('Updated!', 'Portfolio updated successfully!', 'success');
        setEditingId(null);
      } else {
        // ADD NEW
        await createPortfolio(formData);
        Swal.fire('Added!', 'Portfolio added successfully!', 'success');
      }

      setValues({ image: null, name: '' });
      document.getElementById('portfolioImage').value = ''; // clear file input
      fetchPortfolioData();
    } catch (error) {
      console.error('Error saving portfolio:', error);
      Swal.fire('Error', 'Failed to save portfolio item.', 'error');
    }
  };

  const handleEdit = (portfolio) => {
    setEditingId(portfolio.id);
    setValues({
      image: null, // Don't preload image
      name: portfolio.name,
    });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This will permanently delete the portfolio item.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deletePortfolio(id);
          setPortfolioData(portfolioData.filter((item) => item.id !== id));
          Swal.fire('Deleted!', 'The portfolio has been deleted.', 'success');
        } catch (error) {
          Swal.fire('Error', 'Failed to delete portfolio item.', 'error');
          console.error('Delete error:', error);
        }
      }
    });
  };

  return (
    <div>
      <Sidebar />
      <div className="col-md-9 px-0" style={{ marginLeft: '250px' }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <h5 className="page-title">{editingId ? 'Update' : 'Add'} Portfolio</h5>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-8">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="portfolioImage" className="form-label">
                    Portfolio Image
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="portfolioImage"
                    accept="image/*"
                    name="image"
                    onChange={handleChange}
                    required={!editingId} // Only required for add
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="portfolioTitle" className="form-label">
                    Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="portfolioTitle"
                    name="name"
                    placeholder="Enter Name"
                    value={values.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary">
                  {editingId ? 'Update' : 'Add'} Portfolio
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-9 mt-5" style={{ marginLeft: '250px' }}>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>#</th>
              <th>Image</th>
              <th>Name</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {portfolioData.length > 0 ? (
              portfolioData.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>
                    <img
                      src={
                        item.imageBytes
                          ? `data:image/jpeg;base64,${item.imageBytes}`
                          : 'https://via.placeholder.com/100'
                      }
                      alt={item.name}
                      style={{ width: '100px', height: '100px' }}
                    />
                  </td>
                  <td>{item.name}</td>
                  <td>{item.date}</td>
                  <td>
                    <button
                      className="btn btn-primary"
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={() => handleDelete(item.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  No portfolio items found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Portfolioupdate;